import BaseMixin from "@/mixins/http/Base";
import { Component } from "vue-property-decorator";
import { API_ENDPOINT } from "@/constants";
import ClientCompany from "@/models/Agents/Company";

export enum AgentsCompanyMixinTags {
  GetCompanies = "get_companies",
  AssignPrincipal = "assign_principal",
  MultipleAssignPrincipal = "multiple_assign_principal",
}

@Component
export default class CompanyMixin extends BaseMixin {
  getCompanies(
    tag: string,
    slug: string,
    params?: any
  ): Promise<ClientCompany[]> {
    const queryString = this.paramsToQueryString(params);
    const url = API_ENDPOINT + `/${slug}/agents/companies.json?${queryString}`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "GET",
    });
  }

  // currently not used in the codebase.
  assignPrincipal(id: number, slug: string, principalId: string, tag: string) {
    const url =
      API_ENDPOINT + `/${slug}/agents/companies/${id}/assign_principal.json`;

    const data = {
      principalId,
    };
    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "PUT",
      data,
    });
  }

  multipleAssignPrincipal(
    ids: number[],
    slug: string,
    principalId: string,
    tag: string
  ) {
    const url =
      API_ENDPOINT + `/${slug}/agents/companies/multiple_assign_principal.json`;

    const data = {
      ids,
      principalId,
    };
    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "POST",
      data,
    });
  }
}
